<template>
  <div class="login-container">
    <img class="login_logo" :src="loginImg" alt="" />
    <div class="login_info">
      <div class="login_info_left">
        <div class="info_title">联帮帮网络货运平台</div>
        <img
          class="info_img"
          src="../../assets/login/img_denglu_nor@2x.png"
          alt=""
        />
      </div>
      <div class="login_info_right">
        <div class="login_info_one">
          <img
            class="info_one_img"
            src="../../assets/login/img_zhuangshi_nor@2x.png"
            alt=""
          />
        </div>
        <div class="login_info_two">
          <el-form
            ref="loginForm"
            onsubmit="return false;"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            label-position="left"
          >
            <div v-if="0" class="title-container">
              <h3 class="title">
                <img :src="loginImg" alt="" />
                <!-- {{ $t('login.title') }} -->
              </h3>
              <!-- <lang-select class="set-language" /> -->
            </div>
            <div class="login-form_title">登录</div>
            <el-form-item
              prop="username"
              :style="errType ? ' border: 1px solid #ef4141;' : ''"
            >
              <span class="svg-container">
                <svg-icon icon-class="user" />
              </span>
              <el-input
                ref="username"
                v-model="loginForm.username"
                class="elInput"
                :placeholder="$t('login.username')"
                name="username"
                type="text"
                tabindex="1"
                autocomplete="on"
                @keyup.enter.native="inptnext"
                @focus="errType = false"
              />
            </el-form-item>

            <el-tooltip
              v-model="capsTooltip"
              content="Caps lock is On"
              placement="right"
              manual
            >
              <el-form-item
                prop="userPwd"
                :style="errType ? ' border: 1px solid #ef4141;' : ''"
              >
                <span class="svg-container">
                  <svg-icon icon-class="password" />
                </span>
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.userPwd"
                  class="elInput"
                  :type="passwordType"
                  :placeholder="$t('login.password')"
                  name="password"
                  tabindex="2"
                  autocomplete="off"
                  @keyup.native="checkCapslock"
                  @blur="capsTooltip = false"
                  @focus="errType = false"
                />
                <!-- autocomplete="on" -->
                <span class="show-pwd" @click="showPwd">
                  <svg-icon
                    :icon-class="
                      passwordType === 'password' ? 'eye' : 'eye-open'
                    "
                  />
                </span>
                <!-- <div class="forget_pwd">忘记密码？</div> -->
                <div v-if="errType" class="error_pwd">账号或密码错误</div>
              </el-form-item>
            </el-tooltip>
            <el-form-item v-if="false" prop="branchCode">
              <span class="svg-container">
                <svg-icon icon-class="list" />
              </span>
              <el-select
                v-model="loginForm.branchCode"
                class="elInput"
                placeholder="请选择机构"
                clearable
                style="width: 90%"
                @change="setPartyGroupCode"
              >
                <el-option
                  v-for="item in partyGroupList"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="isLoginNeedSMS == 'yes'"
              prop="phoneCode"
              :rules="[
                { required: true, message: '请输入验证码', trigger: 'blur' },
              ]"
            >
              <el-row>
                <el-col :span="20">
                  <div class="grid-content bg-purple">
                    <span class="svg-container">
                      <svg-icon icon-class="Moblie" />
                    </span>
                    <el-input
                      v-model="loginForm.phoneCode"
                      class="elInput"
                      maxlength="20"
                      :placeholder="$t('login.phonecode')"
                      type="text"
                    />
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content bg-purple-light">
                    <span
                      v-show="show"
                      style="padding-right: 5px"
                      @click="getCode"
                      >获取验证码</span
                    >
                    <span v-show="!show" class="count">{{ count }} s</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>

            <Verify
              v-if="verifyShow"
              :bar-size="{ width: '302px', height: '40px' }"
              :v-offset="5"
              :type="3"
              @success="alert('success')"
              @error="alert('error')"
            />
            <el-button
              id="automaticLogon"
              :disabled="logindisbled"
              :loading="loading"
              type="primary"
              :class="{ on_button: !logindisbled }"
              style="width: 100%"
              @click.native.prevent="handleLogin('loginForm')"
            >
              {{ $t("login.logIn") }}
            </el-button>
            <!-- <div class="go_register">
              <div class="register_box" @click="goPage('/register')">
                <div class="register_warn">还没有账号？</div>
                <div class="register_button">去注册</div>
              </div>
            </div> -->
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('login.thirdparty')" :visible.sync="showDialog">
      {{ $t("login.thirdpartyTips") }}
      <br />
      <br />
      <br />
      <social-sign />
    </el-dialog>
    <div class="footer">
      <!-- <img src="../../assets/login/footerimg.png" /> -->
    </div>
    <vxe-modal
      v-model="verificationFlag"
      :show-header="false"
      title="验证码"
      width="450"
      height="250"
      resize
    >
      <verification ref="verificationRef" @receive="receive" @cancel="cancel" />
    </vxe-modal>
    <div class="filing">
      【鲁公网安备 *****号】  网站备案/许可证号:【鲁ICP备2022004558号-1】
      Copyright 2024 瑞源控股集团版权所有
    </div>
  </div>
</template>

<script>
// import LangSelect from '@/components/LangSelect'
import SocialSign from "./components/SocialSignin";
import request from "@/utils/request";
import Verify from "vue2-verify";
import verification from "@/views/register/components/verification";
import Fingerprint2 from "fingerprintjs2";
import { validatePhone } from "@/utils/validate.js";
import { Getverificationcode } from "@/api/user";
const Base64 = require("js-base64").Base64;
export default {
  name: "internal",
  components: { SocialSign, Verify, verification },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("密码长度最低位8位"));
      } else {
        callback();
      }
    };
    return {
      errType: false, //账号密码错误
      loginImg: "",
      logindisbled: true,
      verifyShow: true,
      loginForm: {
        client_id: "4111ea97dffa163e9d2a183dea15fweb",
        client_secret: "f11ffb5c041b11ea97dffa163e9d2a29",
        grant_type: "password",
        response_type: "token",
        device_id: "0000000000",
        username: "",
        userPwd: "", //用户密码
        password: "",
        time: "",
        branchCode: "",
        phoneCode: "",
      },
      verificationFlag: false,
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        userPwd: [
          { required: true, trigger: "blur", validator: validatePassword },
        ],
        branchCode: [
          { required: true, trigger: "blur", message: "请选择机构" },
        ],
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      partyGroupList: [],
      show: true,
      count: "",
      timer: null,
      loginAdminPhone: "",
      isLoginNeedSMS: "",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.$route.query.uid) {
      const _uid = this.$route.query.uid;
      if (_uid != "" || typeof _uid != "undefined") {
        const jmUuid = Base64.decode(_uid);
        const dxUid = this.sortString(decodeURIComponent(jmUuid));
        const jmUid = Base64.decode(dxUid);
        const oneSub = this.getCaption(jmUid, 0);
        this.loginForm.username = this.getCaption(oneSub, 0);
        this.loginForm.userPwd = this.getCaption(jmUid, 1);
        this.logindisbled = false;
        //document.getElementById("automaticLogon").click();
        this.handleLogin("loginForm");
      }
    }
  },
  created() {
    this.getFingerprint();
    // window.addEventListener('storage', this.afterQRScan)
    request({
      url: "/ntocc-basic-api/partyGroup/getDefault",
      method: "get",
    }).then((response) => {
      this.loginImg = response.data.loginLogoUrl;
      this.$store.dispatch("enterprise/setEnterprise", response.data);
      // document.title = response.data.groupName
      // 将平台名称放进缓存
      localStorage.setItem("platformName", response.data.platformName);
      this.isLoginNeedSMS = response.data.isLoginNeedSMS;
      // icon
      // document.querySelector('link[rel="icon"').href = response.data.subscript || ""
    });
    this.getPartyGroup();
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    inptnext(val) {
      this.$refs.password.focus();
    },
    getFingerprint() {
      Fingerprint2.get((components) => {
        const values = components.map(function (component, index) {
          if (index === 0) {
            //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
            return component.value.replace(/\bNetType\/\w+\b/, "");
          }
          return component.value;
        });
        // 生成最终id murmur
        // console.log(values)  //使用的浏览器信息
        const murmur = Fingerprint2.x64hash128(values.join(""), 31);
        this.loginForm.device_id = murmur;
      });
    },
    // 获取机构信息
    getPartyGroup() {
      request({
        url: "/ntocc-basic-api/partyGroup/list",
        method: "get",
      }).then((response) => {
        this.partyGroupList = response.data;
        // 默认选中第一个
        this.loginForm.branchCode = response.data[0].code;
        this.loginAdminPhone = response.data[0].telephone;
      });
    },
    // 选择组织机构
    setPartyGroupCode(value) {
      this.loginForm.branchCode = value;
      let newList = this.partyGroupList.filter((item) => item.code == value);
      this.loginAdminPhone = newList[0].telephone;
    },
    alert(text) {
      if ("success" == text) {
        this.logindisbled = false;
      } else if ("error" == text) {
        this.logindisbled = true;
      }
    },
    //字符截取
    getCaption(obj, state) {
      let index = obj.lastIndexOf("_");
      if (state == 0) {
        obj = obj.substring(0, index);
      } else {
        obj = obj.substring(index + 1, obj.length);
      }
      return obj;
    },
    //倒序
    sortString(str) {
      return str.split("").reverse("").join("");
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (
          (shiftKey && key >= "a" && key <= "z") ||
          (!shiftKey && key >= "A" && key <= "Z")
        ) {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
    },
    handleLogin(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.isLoginNeedSMS == "yes") {
            this.doLogin();
          } else {
            this.getNeedImageVerify();
          }
        } else {
          return false;
        }
      });
    },
    doLogin() {
      this.loading = true;
      const mw = "X2FycGFf";
      const jm = Base64.decode(mw);
      const time = this.$XEUtils.toDateString(new Date(), "yyyyMMddHHmmss");
      const password = Base64.encode(this.loginForm.userPwd + jm + time);
      this.loginForm.time = time;
      this.loginForm.password = password;

      this.$store
        .dispatch("user/login", this.loginForm)
        .then((passWordOverdue) => {
          this.errType = false;
          if (passWordOverdue) {
            this.$message({
              message: "密码未定期更换，请及时修改密码！",
              type: "warning",
            });
          }
          request({
            url: "/ntocc-basic-api/middleStation/getMsg",
            method: "get",
          })
            .then((response) => {
              if (response.msg) {
                this.$message({ message: response.msg, type: "warning" });
              }
            })
            .finally(() => {
              this.$router.push({
                path: this.redirect || "/",
                query: this.otherQuery,
              });
            });
        })
        .catch(() => {
          this.errType = true;
          this.logindisbled = true;
          this.loading = false;
          this.verifyShow = false;
          this.$nextTick(() => {
            this.verifyShow = true;
          });
        });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    getCode() {
      let phone = this.loginForm.username;
      if (!phone) {
        this.$message.error("请先输入账号");
        return false;
      } else {
        if (!validatePhone(phone)) {
          phone = this.loginAdminPhone;
        }
        if (phone) {
          this.verificationFlag = true;
          this.imgurl =
            this.BASE_API_URL +
            "ntocc-tps-api/sms/getVerificationCodeImage?phone=" +
            phone +
            "&imageWith=300&imageHeigth=100&t=" +
            new Date().getTime();
          this.$refs.verificationRef.getVerificationCodeImage(this.imgurl);
        } else {
          this.$message.error("无有效手机号，无法发送验证码");
          return false;
        }
      }
    },
    // 获取登录是否需要图像验证码
    getNeedImageVerify() {
      request({
        url: "/ntocc-basic-api/authorize/imageVerify",
        method: "get",
        params: {
          username: this.loginForm.username,
          branchCode: this.loginForm.branchCode,
        },
      }).then((response) => {
        if (response.data.needImage == "1") {
          // 获取图形验证码
          this.verificationFlag = true;
          this.imgurl =
            this.BASE_API_URL +
            "ntocc-tps-api/sms/getVerificationCodeImage?phone=" +
            this.loginForm.username +
            "&imageWith=300&imageHeigth=100&t=" +
            new Date().getTime();
          this.$refs.verificationRef.getVerificationCodeImage(this.imgurl);
        } else {
          this.doLogin();
        }
      });
    },
    cancel() {
      this.verificationFlag = false;
    },
    receive(imageCode) {
      this.verificationFlag = false;
      if (this.isLoginNeedSMS == "yes") {
        let phone = this.loginForm.username;
        if (!validatePhone(phone)) {
          phone = this.loginAdminPhone;
        }
        let cationCode = {
          partyGroupCode: this.loginForm.branchCode,
          imageCode: imageCode,
          phone: phone,
        };
        Getverificationcode(cationCode).then((response) => {
          if (response.status == 0) {
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      } else {
        this.loginForm.phoneCode = imageCode;
        this.doLogin();
      }
    },
    // goPage(redirect) {
    //   this.$router.push(redirect);
    // },
  },
};
</script>

<style lang="scss" >
$bg: #e7f0fe;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .elInput input {
    color: $cursor;
  }
}
/* reset element-ui css */
.login-container {
  .elInput {
    display: inline-block;
    height: 47px;
    width: 80%;
    background: #fff;

    input {
      background: #fff;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
      &:-webkit-autofill,
      textarea:-webkit-autofill,
      select:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
        background-color: transparent;
        background-image: none;
        transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    // background: rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 5px;
    color: #000000;
    margin-bottom: 30px;
    position: relative;

    .forget_pwd {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 11px;
      color: #4186ef;
      line-height: 13px;
      position: absolute;
      bottom: -20px;
      right: 0;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
    .error_pwd {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 11px;
      color: #ef4141;
      line-height: 13px;
      position: absolute;
      bottom: -20px;
      left: 0;
    }
  }
  .verify-bar-area {
    width: 305px !important;
    background: #ededed;
    margin-bottom: 1.56vw;
  }
  .verify-btn {
    display: none;
  }
  .verify-move-block {
    border-radius: 5px 0 0 5px;
  }
  .verify-bar-area .verify-left-bar {
    border-radius: 5px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #e7f0fe;
$dark_gray: #889aa4;
$light_gray: #eee;
@media screen and (min-width: 1900px) {
  .login-container {
    // min-height: 1000px;
    background-color: $bg;
    //overflow: hidden;
    // background: url('../../assets/login/loginimg.png');
    // background-size: 100% 100%;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .login_logo {
      width: 104px;
      height: 38px;
      position: absolute;
      top: 26px;
      left: 51px;
    }
    .filing {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 30px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #8b929c;
      line-height: 16px;
    }
    .login_info {
      width: 1572px;
      height: 783px;
      background: #f3f6ff;
      display: flex;
      .login_info_left {
        flex: none;
        width: 794px;
        margin-left: 151px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .info_title {
          margin-top: 111px;
          font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 36px;
          color: #4589f0;
          line-height: 42px;
          text-align: center;
        }
        .info_img {
          margin-top: 8px;
          width: 794px;
          height: 559px;
        }
      }
      .login_info_right {
        flex: 1;
        height: 783px;
        background: #f9fbfe;
        position: relative;
        .login_info_one {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          .info_one_img {
            width: 396px;
            height: 230px;
          }
        }
        .login_info_two {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
    .login-form {
      position: relative;
      width: 312px;
      // max-width: 100%;
      // padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;
      .login-form_title {
        width: 100%;
        text-align: center;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #4589f0;
        line-height: 42px;
        margin-top: 162px;
        margin-bottom: 57px;
      }
      .on_button {
        &:hover {
          opacity: 0.8;
        }
      }
      .go_register {
        margin-top: 57px;
        width: 100%;
        display: flex;
        justify-content: center;
        .register_box {
          width: 137px;
          height: 28px;
          background: #e8edf4;
          border-radius: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          .register_warn {
          }
          .register_button {
            color: #4186ef;
          }
        }
      }
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      font-size: 16px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 20px auto;
        text-align: center;
        font-weight: bold;
        img {
          width: 80%;
        }
      }

      .set-language {
        color: #fff;
        position: absolute;
        top: 3px;
        font-size: 18px;
        right: 0px;
        cursor: pointer;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
  }
}
@media screen and (max-width: 1900px) {
  .login-container {
    min-height: 500px;
    background-color: $bg;
    //overflow: hidden;
    // background: url('../../assets/login/loginimg.png');
    // background-size: 100% 100%;
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .login_logo {
      width: 104px;
      height: 38px;
      position: absolute;
      top: 1.35vw;
      left: 2.66vw;
    }
    .filing {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 1vw;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #8b929c;
      line-height: 16px;
    }
    .login_info {
      width: 81.88vw;
      height: 35.78vw;
      min-height: 435px;
      background: #f3f6ff;
      display: flex;
      .login_info_left {
        flex: none;
        width: 41.35vw;
        margin-left: 7.86vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        .info_title {
          margin-top: 5.78vw;
          font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
          font-weight: bold;
          font-size: 36px;
          color: #4589f0;
          line-height: 42px;
          text-align: center;
        }
        .info_img {
          margin-top: calc(8px + (794px - 25.12vw) / 12);
          width: 30.35vw;
          height: 21.12vw;
        }
      }
      .login_info_right {
        flex: 1;
        height: 35.78vw;
        min-height: 435px;
        background: #f9fbfe;
        position: relative;
        .login_info_one {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          .info_one_img {
            width: 396px;
            height: 230px;
          }
        }
        .login_info_two {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
    .login-form {
      position: relative;
      width: 312px;
      // max-width: 100%;
      // padding: 160px 35px 0;
      margin: 0 auto;
      overflow: hidden;
      .login-form_title {
        width: 100%;
        text-align: center;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #4589f0;
        line-height: 42px;
        margin-top: 4vw;
        margin-bottom: 2vw;
      }

      .on_button {
        &:hover {
          opacity: 0.8;
        }
      }
      .go_register {
        margin-top: 2vw;
        width: 100%;
        display: flex;
        justify-content: center;
        .register_box {
          width: 137px;
          height: 28px;
          background: #e8edf4;
          border-radius: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
          .register_warn {
          }
          .register_button {
            color: #4186ef;
          }
        }
      }
    }

    .tips {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;

      span {
        &:first-of-type {
          margin-right: 16px;
        }
      }
    }

    .svg-container {
      padding: 6px 5px 6px 15px;
      font-size: 16px;
      color: $dark_gray;
      vertical-align: middle;
      width: 30px;
      display: inline-block;
    }

    .title-container {
      position: relative;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0px auto 20px auto;
        text-align: center;
        font-weight: bold;
        img {
          width: 80%;
        }
      }

      .set-language {
        color: #fff;
        position: absolute;
        top: 3px;
        font-size: 18px;
        right: 0px;
        cursor: pointer;
      }
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }
  }
}
.footer {
  position: fixed;
  bottom: 50px;
  left: 50%;
  margin-left: -100px;
  img {
    width: 70%;
  }
}
.bg-purple-light {
  span {
    color: #fff;
    line-height: 50px;
    font-size: 13px;
    text-align: right;
    display: block;
  }
}
</style>
